<template>
  <!-- -->
  <div class="road-message-ws-home-top">
    <common-message-ws-home-top>
      <table-button @click="router.push(`/monitor`)">数据中台</table-button>
    </common-message-ws-home-top>
  </div>
</template>

<script>

import CommonMessageWsHomeTop from "@/views/h5/common/home/components/top/CommonMessageWsHomeTop.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import {useRoute, useRouter} from "vue-router";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    TableButton,
    CommonMessageWsHomeTop,
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>

</style>